import type { RouteLocationNormalized } from 'vue-router';

export const getLoginWithRedirect = (to: RouteLocationNormalized) => ({
  name: 'login',
  query: {
    redirect: encodeURIComponent(to.fullPath),
  },
});
